export default "__VITE_ASSET__BZrHsZ3q__"